import { connect } from 'react-redux';

import withRouter from '../component/WithRouter.jsx';

import FlixDetailReaction from '../component/FlixDetailReaction.jsx';

import login from '../action/login.js';
import sendChatStart from '../action/sendChatStart.js';
import submitMessageRating from '../action/submitMessageRating.js';
import setGiftPanel from '../action/setGiftPanel.js';
import copyTextWithToastr from '../action/copyTextWithToastr.js';

import getMeData from '../selector/getMeData.js';
import getMessageData from '../selector/getMessageData.js';
import getMessageUnlockPrice from '../selector/getMessageUnlockPrice.js';
import getUserData from '../selector/getUserData.js';
import getUsername from '../selector/getUsername.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';
import { SHARE_CONTENT_VIDEO } from '../RemoteConfigKeys.js';
import fetchMeReferral from '../action/fetchMeReferral.js';

const mapStateToProps = (state, { messageId, location }) => {
  const unlockPrice = getMessageUnlockPrice(state, messageId);
  const senderId = getMessageData(state, messageId, 'senderId');
  const likeCount = getMessageData(state, messageId, 'likes');
  const isOnFreezoneDetail = getIsMatchedPathname({
    pathname: location?.pathname,
    dataKey: 'isOnFreezoneDetail',
  });
  const referralCode = getMeData(state, 'referralCode');
  const referralSignupRewardDiamond = getMeData(state, 'rewardReferral');

  const meId = getMeData(state, 'id');
  const selectPath = ['me', 'referral', meId];
  const isFetching = getNetworkingData(state, selectPath, 'isFetching');
  const isFetched = getNetworkingData(state, selectPath, 'isFetched');
  const shouldFetchReferral = !isFetching && !isFetched;

  const shareI18nVideoTemplates = getRemoteConfigData(
    state,
    SHARE_CONTENT_VIDEO
  );

  return {
    meId,
    messageId,
    isOnFreezoneDetail,
    isPublished: getMessageData(state, messageId, 'isPublished'),
    senderId,
    senderUsername: getUserData(state, senderId, 'username'),
    displayedSenderUsername: getUsername(state, senderId, 'displayNameFirst'),
    ratedAs: getMessageData(state, messageId, 'ratedAs'),
    likeCount,
    unlockPrice,
    referralCode,
    referralSignupRewardDiamond,
    shouldFetchReferral,
    shareI18nVideoTemplates,
  };
};

const mapDispatchToProps = (dispatch, { messageId }) => {
  return {
    login: data => dispatch(login(data)),
    sendChatStart: ({ userId }) => dispatch(sendChatStart({ userId })),
    submitMessageRating: ({ rating }) =>
      dispatch(submitMessageRating({ id: messageId, rating })),
    setGiftPanel: ({ isOpen }) => dispatch(setGiftPanel({ isOpen })),
    copyTextWithToastr: data => dispatch(copyTextWithToastr(data)),
    fetchMeReferral: () => dispatch(fetchMeReferral()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FlixDetailReaction)
);
